import { deleteSubtaskService } from 'owa-todo-service';
import { getTodoCache } from '../todoCache';

export async function deleteSubtodo(parentTodoId: string, subtodoId: string): Promise<boolean> {
    const originalSubtodos = getTodoCache().selectItemById(parentTodoId)?.Subtasks;
    if (!originalSubtodos || originalSubtodos.length <= 0) {
        return true;
    }

    const updatedSubtodos = originalSubtodos.filter(subtodo => subtodo.Id !== subtodoId);

    // remove local subtodo
    getTodoCache().updateItem(parentTodoId, { Subtasks: updatedSubtodos });

    // kick off delete operation
    const successfullyDeleted = await deleteSubtaskService(parentTodoId, subtodoId);

    // add back the removed subtodo if the operation fails
    if (!successfullyDeleted) {
        getTodoCache().updateItem(parentTodoId, { Subtasks: originalSubtodos });
    }

    return successfullyDeleted;
}
